import React, {useState} from "react";
import Chart from "react-apexcharts";
import {CHART_NODATA_CONSTANT, consumptionChartOptions,} from "../Constants";
import {Button, ConfigProvider, Table} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {SET_SINGLE_METER_VALUE, SET_VIEW_SINGLE_METER} from "../../../store/features/systemAnalysisSlice";
import { clientColumnSorter } from "../../../utils/tableClientSort";

export const ConsumptionAnalysis = ({showTable = false, analysisData = {}}) => {
    return (
        <div className={`grid grid-cols-2 gap-4`}>
            <div className={`${showTable ? "" : "col-span-2"}`}>
                <ConsumptionAnalysisChart analysisData={analysisData}/>
            </div>
            {showTable && (
                <div>
                    <ConsumptionAnalysisTable analysisData={analysisData}/>
                </div>
            )}
        </div>
    );
};

const ConsumptionAnalysisChart = ({analysisData = {}}) => {
    return (
        <Chart
            key={"ConsumptionAnalysisContentChart"}
            options={{
                ...CHART_NODATA_CONSTANT,
                chart: consumptionChartOptions?.options?.chart,
                labels: analysisData?.chart?.labels ?? [], //
            }}
            series={analysisData?.chart !== undefined ? analysisData?.chart?.series?.map((val) => {
                return {
                    ...val,
                    type: val?.type?.toLowerCase()
                }
            }) : []}

            type="line"
            height={500}
        />
    );
};
const ConsumptionAnalysisTable = ({analysisData = {}}) => {
    const dispatch = useDispatch();
    const {viewSingleMeter, consumptionLimitMax} = useSelector((state) => state.SystemAnalysis);
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 14,
            pageSize: 3,
            total: analysisData?.tabularDatas?.length ?? 0,
        },
    });

    return (
        <ConfigProvider
            theme={{
                token: {
                    borderRadius: 0,
                },
                components: {
                    Table: {
                        /* here is your component tokens */
                        headerBg: "#F5F5F5",
                        headerColor: "#2F5E8A",
                        headerSortActiveBg: "#F5F5F5",
                        headerSortHoverBg: "#F5F5F5",
                        fixedHeaderSortActiveBg: "#F5F5F5",
                    },
                },
            }}
        >
            <Table
                className="table-striped-rows"
                dataSource={analysisData?.tabularDatas ?? []}
                //   rowSelection={{ type: "checkbox", ...rowSelection }}
                columns={[
                    {
                        title: !viewSingleMeter ? "Serial Number" : "Date",
                        dataIndex: "data",
                        sorter: clientColumnSorter("data"),
                        render: (text) => {
                            return (
                                <>
                                    {!viewSingleMeter ? <Button
                                        onClick={() => {
                                            dispatch(SET_SINGLE_METER_VALUE(text));
                                            dispatch(SET_VIEW_SINGLE_METER(true));
                                        }}
                                    >
                                        <p className="text-dark-blue-100">{text}</p>
                                    </Button> : <div>{text}</div>}
                                </>
                            );
                        },
                    },
                    {
                        title: "Daily Total (m3)",
                        dataIndex: "m3",
                        sorter: clientColumnSorter("m3"),
                    },
                    {
                        title: "DAVC",
                        dataIndex: "davc",
                        sorter: clientColumnSorter("davc"),
                    },
                    {
                        title: "Consumption Drop",
                        dataIndex: "consumptionDropInPercentage",
                        sorter: clientColumnSorter("consumptionDropInPercentage"),
                        render: (text) => {
                            return (
                                <>
                                    <div>
                                        <p className={`${text > consumptionLimitMax ? "text-red-600":"text-dark-blue-100"}`}>{text}</p>
                                    </div>
                                </>
                            );
                        },
                    },
                ]}
                pagination={tableParams}
                // showSizeChanger={true}
            ></Table>
        </ConfigProvider>
    );
};
